import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M452 0H60C27 0 0 27 0 60v392c0 33 27 60 60 60h392c33 0 60-27 60-60V60c0-33-27-60-60-60m20 452c0 11-9 20-20 20H338V309h61.8l10.2-62h-72v-43c0-17 13-30 30-30h41v-62h-41a92 92 0 0 0-92 92.2V247h-60v62h60v163H60c-11 0-20-9-20-20V60c0-11 9-20 20-20h392c11 0 20 9 20 20z" }, null, -1)
  ]))]))
}
export default { render: render }